/*
* 点位采集管理组件
* zxw
* 2025-05-20
*/

import { Component, } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import { Row, Col, message, Table, Input, Select, Button, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    ShowIPModal,
    isGTscreenWidth,
    rootReactDom,
    GetButtonActionName,
} from '../../incs/FunHelper.js';

import Entity from './CollectEntity.js';
import PLCSummary from './PLCSummary.js';

const MODULENAME = CNF.navItems[0].submenu[0].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[0].submenu[0].ptn;
const MODULENAME_URL = CNF.navItems[0].submenu[0].url;

const Lists = (props) => {
    const update = (record) => { props.setOpen(true, record); }

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = (action, record) => {
        let uri = MODULENAME_URL.slice(1,) + '/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                update(record);
                break;
            case CNF.actionName.DISABLE:
            case CNF.actionName.ACTIVE:
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.rolename, action, MODULENAME, props.isRefresh, uri);
                break;
            default:
                break;
        }
    }

    /**
     * 打印点位采集统计
     * @param {*} record 
     */
    const showPLCSummary = (record) => {
        rootReactDom && rootReactDom.render(
            <PLCSummary
                preGroup={props.preGroup}
                btnLists={props.btnLists}
                isModalOpen={true}
                record={record}
            />);
    }

    const columns = [
        { title: '', width: 20, dataIndex: '', key: 'key', fixed: 'left', },
        {
            title: '编号', key: 'number',
            render: (record) => <Button
                color='primary'
                variant='link'
                style={{ padding: '0 5px', border: 0, height: 22 }}
                onClick={() => { showPLCSummary(record); }}>{record.number}</Button>

        },
        { title: '名称', dataIndex: 'name', key: 'name', },
        { title: '所属单位', dataIndex: 'affiliate_unit', key: 'affiliate_unit', },
        { title: '开始日期', dataIndex: 'start_date', key: 'start_date', },
        // { title: '描述', dataIndex: 'description', key: 'description', },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        { title: '状态', key: 'status', dataIndex: 'status', width: CNF.tableStatusColumnWidth, },
        {
            title: '操作', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: (
                props.btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_disable') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_active') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0
            ) ? false : true,
            render: (record) => GetButtonActionName(props.btnLists, MODULENAME_PTN, record, operation)
        }
    ];
    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={props.dataLists}
                pagination={{
                    showSizeChanger: false,
                    // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                    showQuickJumper: false,
                    showTotal: () => `共${props.pageCount > 10000 ? (props.pageCount / 10000).toFixed(CNF.DPL) + '万' : props.pageCount}条`,
                    pageSize: CNF.pageSize,
                    current: props.currentIndex,
                    total: props.pageCount,
                    onShowSizeChange: (current, pageSize) => props.changePageSize(pageSize, current),
                    onChange: (current) => props.changeIndex(current),
                }}
            />
        </>
    );
}

class CPT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: null,
            open: false,
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            number: '',
            name: '',
            status: CNF.status[0].value,
        }
    }

    isRefresh = () => { this.setState({ isRefresh: this.state.isRefresh === 1 ? 0 : 1 }); }
    search = () => { this.setState({ currentIndex: 1 }); this.isRefresh(); }
    changeNumber = (e) => { this.setState({ number: e.target.value, }); this.search(); }
    changeName = (e) => { this.setState({ name: e.target.value, }); this.search(); }
    changeStatus = (value) => { this.setState({ status: value ? value : '', }); this.search(); }
    changeIndex = (index) => { this.setState({ currentIndex: index }); this.isRefresh(); }

    setOpen = (value, record) => { this.setState({ open: value, record: record }); }
    create = () => { this.setOpen(true, null); }

    /**
     * 获取列表
     */
    getLists() {
        const _this = this;
        const params = {
            'number': this.state.number,
            'name': this.state.name,
            'status': this.state.status,
            'page_size': CNF.pageSize,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}pointLocation/collects${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        })
            .done(function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt
                        });
                    } else {
                        _this.setState({
                            dataLists: [],
                            pageCount: 0
                        });
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            })
            .fail(function (data) {
                message.error(data.responseJSON.detail, CNF.messageDuration);
            })
    }

    componentDidUpdate() {
        if (this.state.init !== this.state.isRefresh) {
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount() {
        this.getLists();
    }

    render() {
        return (
            <>
                <Row style={{ paddingTop: CNF.searchMarginLeft * 4, paddingBottom: CNF.searchMarginLeft * 4, paddingLeft: CNF.searchMarginLeft * 4 }}>
                    <Col span={isGTscreenWidth ? 2 : 3}>
                        <Input
                            onChange={this.changeNumber}
                            placeholder='编码'
                            value={this.state.number}
                        />
                    </Col>
                    <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: 5 }}>
                        <Input
                            onChange={this.changeName}
                            placeholder='名称'
                            value={this.state.name}
                        />
                    </Col>
                    <Col span={2} style={{ marginLeft: 5 }}>
                        <Select
                            allowClear
                            placeholder='状态'
                            style={{ width: '100%' }}
                            onChange={this.changeStatus}
                            options={CNF.status.map((item, index) => ({
                                key: index,
                                value: item.value,
                                label: item.key
                            }))}
                        />
                    </Col>
                    <Space size={CNF.searchMarginLeft} style={{ marginLeft: CNF.searchMarginLeft }}>
                        {
                            this.props.btnLists.indexOf(MODULENAME_PTN + '_create') >= 0 ? (
                                <Button
                                    title={CNF.actionName.CREATE + MODULENAME}
                                    color='primary'
                                    variant='solid'
                                    icon={<PlusOutlined />}
                                    onClick={() => {
                                        this.create();
                                    }}>
                                    {CNF.actionName.CREATE}
                                </Button>
                            ) : ''
                        }
                    </Space>
                    <Entity
                        policy={this.props.policy}
                        preGroup={this.props.preGroup}
                        open={this.state.open}
                        record={this.state.record}
                        setOpen={this.setOpen}
                        isRefresh={this.isRefresh}
                    />
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists
                            btnLists={this.props.btnLists}
                            preGroup={this.props.preGroup}
                            dataLists={this.state.dataLists}
                            currentIndex={this.state.currentIndex}
                            pageCount={this.state.pageCount}
                            changeIndex={this.changeIndex}
                            setOpen={this.setOpen}
                            isRefresh={this.isRefresh}
                        />
                    </Col>
                </Row>
            </>
        );
    }
}

export default CPT